export const productsReducer = (state = { products: [], allproducts: [],listproducts:[] }, action) => {
  switch (action.type) {
    case "GET_PRODUCTS":
      return {
        ...state,
        products: action.payload
      };
    case "GET_LISTS_PRODUCTS":
      return {
        ...state,
        allproducts: action.payload
      };
    case "GET_ALL_LISTS_PRODUCTS":
      return {
        ...state,
        listproducts: action.payload
      };
    case "ADD_PRODUCT":
      return {
        ...state,
        products: [...state.products, action.payload],
      };
    case "UPDATE_PRODUCT":
      return {
        ...state,
    products: state.products.map(p =>
      p.id === action.payload.id ? action.payload : p
    )
      };
    case "DELETE_PRODUCT":
      return {
        ...state,
        products: [...state.products, action.payload],
      };
    default:
      return state;
  }
};
